import { Chart, Tooltip } from 'chart.js/auto'

window.addEventListener('DOMContentLoaded', () => {
	const charts = document.querySelectorAll('.chartjs-canvas')

	// Create a custom tooltip positioner to put at the top of the chart area
	Tooltip.positioners.top = function (items) {
		const pos = Tooltip.positioners.average(items)
		// Happens when nothing is found
		if (pos === false) {
			return false
		}
		return {
			x: pos.x,
			y:
				items[items.length - 1].element.base -
				items[items.length - 1].element.height,
			xAlign: 'center',
			yAlign: 'bottom',
		}
	}

	// Custom skipped line style
	const skipped = (ctx, value) =>
		ctx.p0.skip || ctx.p1.skip ? value : undefined

	charts.forEach(ctx => {
		const chartId = ctx.dataset.id
		const chartType = window[chartId + '_type']
		const labels = JSON.parse(window[chartId + '_labels'])
		const datasets = JSON.parse(window[chartId + '_datasets'])
		// Add specific properties to datasets based on the chart type
		if (chartType === 'line') {
			datasets.forEach(set => {
				set['segment'] = {
					borderDash: ctx => skipped(ctx, [16, 16]),
				}
				set['spanGaps'] = true
				set['pointRadius'] = 6
				set['pointHoverRadius'] = 8
				set['borderColor'] = set.backgroundColor
			})
		} else {
			datasets.forEach(set => {
				set['borderRadius'] = {
					topLeft: 8,
					topRight: 8,
					bottomLeft: 0,
					bottomRight: 0,
				}
				set['inflateAmount'] = 4
				set['barPercentage'] = 0.75
			})
		}
		const maxVal =
			parseInt(window[chartId + '_maxVal']) + (chartType === 'bar' ? 4 : 0)
		const xAxisTitle = window[chartId + '_xAxisTitle']
		const yAxisTitle = window[chartId + '_yAxisTitle']

		const showLegend = !datasets.every(x => x.label === '')

		new Chart(ctx, {
			type: chartType ?? 'line',
			data: {
				labels: labels,
				datasets: datasets,
			},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				interaction: {
					mode: 'index',
				},
				scales: {
					x: {
						title: {
							display: xAxisTitle ? true : false,
							text: xAxisTitle,
							font: {
								family: 'Arboria',
								size: 14,
								weight: 'bold',
							},
						},
						stacked: chartType === 'bar' ? true : false,
						ticks: {
							font: {
								family: 'Arboria',
								size: 14,
							},
						},
						grid: {
							lineWidth: 0,
						},
						border: {
							display: false,
						},
					},
					y: {
						title: {
							display: yAxisTitle ? true : false,
							text: yAxisTitle,
							font: {
								family: 'Arboria',
								size: 14,
								weight: 'bold',
							},
						},
						stacked: chartType === 'bar' ? true : false,
						beginAtZero: true,
						border: {
							display: false,
						},
						suggestedMax: maxVal,
						ticks: {
							stepSize: Math.ceil(maxVal / 4),
							font: {
								family: 'Arboria',
								size: 14,
							},
						},
					},
				},
				plugins: {
					tooltip: {
						enabled: false,
						position: chartType === 'bar' ? 'top' : 'nearest',
						yAlign: 'bottom',
						external: function (context) {
							const { chart, tooltip } = context
							// Tooltip Element
							let tooltipEl = document.getElementById('chartjs-tooltip')

							// Create element on first render
							if (!tooltipEl) {
								tooltipEl = document.createElement('div')
								tooltipEl.id = 'chartjs-tooltip'
								tooltipEl.style.opacity = 1

								const container = document.createElement('div')

								tooltipEl.appendChild(container)
								document.body.appendChild(tooltipEl)
							}

							// Hide if no tooltip
							const tooltipModel = tooltip
							if (tooltipModel.opacity === 0) {
								tooltipEl.style.opacity = 0
								return
							}

							// Set caret Position
							tooltipEl.classList.remove('above', 'below', 'no-transform')
							if (tooltipModel.yAlign) {
								tooltipEl.classList.add(tooltipModel.yAlign)
							} else {
								tooltipEl.classList.add('no-transform')
							}

							function getBody(bodyItem) {
								return bodyItem.lines
							}

							// Set Text
							if (tooltipModel.body) {
								const titleLines = tooltipModel.title || []
								const bodyLines = tooltipModel.body.map(getBody)

								let innerHtml = '<div class="heading">'

								titleLines.forEach(function (title) {
									innerHtml += `<p class="h6">${title}</strong></p>`
								})
								innerHtml += '</div><div class="body">'

								bodyLines.reverse().forEach(function (body, i) {
									const colors = tooltipModel.labelColors.slice(0).reverse()[i]
									let style = `--color: ${colors.backgroundColor}`
									innerHtml += `<p class="item" style="${style}">${body}</p>`
								})
								innerHtml += '</div>'

								let containerRoot = tooltipEl.querySelector('div')
								containerRoot.innerHTML = innerHtml
							}

							const position = chart.canvas.getBoundingClientRect()

							// Display, position, and set styles for font
							tooltipEl.style.opacity = 1
							tooltipEl.style.left =
								position.left + window.pageXOffset + tooltipModel.caretX + 'px'
							tooltipEl.style.top =
								position.top + window.pageYOffset + tooltipModel.caretY + 'px'
						},
						callbacks: {
							label: function (context) {
								let label = context.dataset.label || ''
								if (label) {
									label += ': '
								}

								// Use the raw value to see NaN instead of the parsed 0
								let value = context.raw

								// Manually return 'NaN' if the value is null, undefined, or NaN
								if (
									value === null ||
									typeof value === 'undefined' ||
									isNaN(value)
								) {
									return label + 'N/A'
								}

								if (yAxisTitle) {
									value += ' ' + yAxisTitle
								}

								return label + value
							},
						},
					},
					legend: {
						display: showLegend,
						position: 'bottom',
						reverse: true,
						labels: {
							boxWidth: 6,
							boxHeight: 6,
							usePointStyle: true,
							pointStyle: 'circle',
							padding: 20,
							font: {
								family: 'Arboria',
								size: 14,
							},
						},
					},
				},
				transitions: {
					show: {
						animations: {
							y: {
								from: 1000,
							},
						},
					},
					hide: {
						animations: {
							y: {
								to: 1000,
							},
						},
					},
				},
			},
		})
	})
})
